import React, { useState, useEffect } from "react";
import { Link, useParams, useLocation, Navigate, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import request from "../../Apis/request";
import "./filtercategory.css";
import axios from "axios";
import ReactPaginate from 'react-paginate'; 

  function Testing() {
  document.title = "Versions";
  const [FilterCategoryData, setFilterCategoryData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [userStatuses, setUserStatuses] = useState({});
  const [selectedStatusType, setSelectedStatusType] = useState("0");
  const [statusListing, setStatusListing] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(0); 
  const [page, setPage] = useState(1); 
  const [Limit, setLimit] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("");
  let navigate = useNavigate();

    const { pid } = useParams();
    const FetchfiltercategoryData = async () => { 
    setLoadings(true);
  
    // Base URL with the common parameters
    let url = `${BaseURL}/version`;
  
    try {
      const res = await request({
        url: url,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  console.log("response", res);
      if (res && res?.data) {
        setFilteredData(res?.data);
    } else {
        setFilteredData([]); // If no data, ensure filteredData is empty
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilteredData([]); // In case of error, set filteredData to empty
    } finally {
      setLoadings(false);
    }
  };
  
  useEffect(() => {
    FetchfiltercategoryData(page);  
  }, [page]);  // Re-fetch when page changes

  const NameArray = ["Vivek", "Aman", "Mayank"];
  const A = [1,2,3,4];
   const updatedArray =  A.splice(2,1, 4);
 const NewArray =  NameArray.splice(2, "Anupam");
//  const updatedArray = NameArray.reverse();

  console.log("NameArray", NameArray);
  console.log("updatedArray", updatedArray);
  console.log("A", A);
  
  return (
    <>
     <div className="container-fluid">
  <div className="row">
    <div className="col-sm-12">
      <div className="card">
        <div className="card-header pb-0" style={{padding: "none"}}>

        </div>
      
        <div
  className="d-flex justify-content-between align-items-center"
  style={{ padding: "0" }}
>
  {/* Left-aligned heading */}
  <h4 style={{ margin: 0 }}>
    All Versions ({filteredData ?filteredData.length : "Loading..."})
  </h4>

  {/* Right-aligned button and link */}
  <div className="d-flex align-items-center">
    <select>
      <option>Select Option</option>
      {NameArray && NameArray.map((u, i) => (
<option key ={i} value  = {u}>{u}</option>

     ))}
    </select>
    <button
      className="btn btn-primary"
      style={{
        height: "auto"// Space between button and link
      }}
      onClick={() => navigate(-1)}
    >
      Back
    </button>
   
  </div>
</div>

<hr/>

<div className="card-body" style={{ padding: "10px 0" }}> {/* Add padding to the body */}
  {loadings ? (
    // Loader is shown while loading
    <div className="text-center">
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  ) : filteredData.length > 0 ? (
    <>
    <div className="table-responsive">
      <table className="display dataTable" id="advance-1">
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Old Version</th>
            <th>Latest Version</th>
            <th>Updated Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredData?.map((u, i) => (
            <tr key={u?._id}>
              <td>{ i + 1}</td>
              <td>{u?.title}</td>
              <td>{u?.old_version}</td>
              <td>{u?.latest_version}</td>
              <td>{u?.updatedAt}</td>
             <td>
              &nbsp;&nbsp;&nbsp;
             <Link
                  to={`/versions/edit/${u?._id}`}
                  state={{ VersionEditData: u }}
                > 
                  <i className="fa fa-edit"
                   title="Edit Version"
                  ></i>
            </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    
    </div>
    
    </>
  ) : (
    // "No Data" message is shown if no data is returned
    <div className="text-center">
      <p>No Data Available</p>
    </div>
  )}
</div>

      </div>
    </div>
  </div>
</div>

    </>
  );
}

export default Testing;
